module.exports = __webpack_public_path__ + "static/img/member02.130b24ae.png";